module.exports = __webpack_public_path__ + "img/gujuncai_pink.4976fbf0.png";